module.exports = __webpack_public_path__ + "img/vlogger.22e93c41.jpg";